import { Document } from "../../../models"
import { createAddDocumentsAction } from "../documents/actions/addDocumentsActions"
import { DocIdToDocument } from "../documents"
import { Dispatch } from "redux"
import { DocumentResponse, constructDocumentDataFromDto } from "../../../utils/processResponse/constructDocumentDataFromDto"

export const processEventsResponse = (dispatch: Dispatch) => (eventsResponse: DocumentResponse[]) : Document[] => {
    const docIdToDocument: DocIdToDocument = {}

    const events = eventsResponse.map((eventResponse: DocumentResponse) => {
        return constructDocumentDataFromDto(eventResponse)
    })

    events.forEach((event: Document) => {
        docIdToDocument[event.docId] = {
            document: event,
            isDeleting: false,
            isUpdating: false,
            isFetching: false
        }
    })

    dispatch(createAddDocumentsAction(docIdToDocument))

    return events;
}